export const classStatusOptions = [
    { 'value': 'Active', "label": "Active" },
    { 'value': 'Deactive', "label": "Deactive", },
]